import { useSelector } from "react-redux";

import BookWorkbookPage from "./book/BookWorkbookPage";
import ChapterBookPage from "./chapter_book/ChapterBookPage";
import DeprecatedComprehensivePage from "./deprecated/DeprecatedComprehensivePage";
import OXPage from "./OX/OXPage";
import ScramblePage from "./scramble/ScramblePage";
import SummaryBlankPage from "./summary/SummaryBlankPage";
import TranslationPage from "./translation/TranslationPage";
import UnderstandingTestPage from "./understanding/UnderstandingTestPage";
import VocabularyPage from "./vocabulary/VocabularyPage";

const ComprehensivePage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  // 챕터북(원서 모드의 한 갈래). 챕터 하나가 섹션 하나다.
  if (section.type === "chapter_book") {
    return (
      <ChapterBookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  // 원서 워크북(지인에듀 mode=book). 세트 하나가 섹션 하나다.
  if (section.type === "book") {
    return (
      <BookWorkbookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  if (section.type === "comprehensive") {
    return (
      <DeprecatedComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "ox_kor",
      "ox_kor_high",
      "ox_eng",
      "ox_eng_high",
      "ox"
    ].includes(section.type)
  ) {
    return (
      <OXPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "paraphrasing_scramble",
      "scramble"
    ].includes(section.type)
  ) {
    return (
      <ScramblePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "summary_blank_low",
      "summary_blank",
      "summary"
    ].includes(section.type)
  ) {
    return (
      <SummaryBlankPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "translation") {
    return (
      <TranslationPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "understanding_test",
      "understanding"
    ].includes(section.type)
  ) {
    return (
      <UnderstandingTestPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "keyword_meaning",
      "keyword"
    ].includes(section.type)
  ) {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "num_repeats") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }
  return <div></div>;
};

export default ComprehensivePage;
